<div class="sectionbar">
  <app-ordre-nav></app-ordre-nav>
  <div class="sectionbar__actions"></div>
</div>
<div class="topbar">
  <h1>Partneroprettede</h1>
  <div class="topbar__actions">
    @if (unparentedOrderAccountings?.length > 0) {
      <small>Viser {{ unparentedOrderAccountings.length }} af {{ rowCount }} ordrer</small>
    }
    <app-unparented-filter [filter]="filter"></app-unparented-filter>
  </div>
</div>
<div class="page__content orders orders--list">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mat-elevation-z2"
    (matSortChange)="sortData($event)"
    [matSortActive]="filter.orderBy"
    [matSortDirection]="filter.orderDir"
    >
    <ng-container matColumnDef="Oprettid">
      <th mat-header-cell mat-sort-header class="date-col" *matHeaderCellDef>Oprettet</th>
      <td
        mat-cell
        class="date-col"
        *matCellDef="let unparentedOrderAccounting"
        [matTooltip]="unparentedOrderAccounting.oprettid | amLocale: 'da' | amCalendar"
        >
        {{ unparentedOrderAccounting.oprettid | date: 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="DeliveryDate">
      <th mat-header-cell mat-sort-header class="date-col" *matHeaderCellDef>Leveringsdato</th>
      <td mat-cell class="date-col" *matCellDef="let unparentedOrderAccounting">
        {{ unparentedOrderAccounting.deliveryDate | date: 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Opgave">
      <th mat-header-cell *matHeaderCellDef>Opgave</th>
      <td mat-cell *matCellDef="let unparentedOrderAccounting">
        {{ unparentedOrderAccounting.opgaveText }}
      </td>
    </ng-container>

    <ng-container matColumnDef="PartnerNo">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Partner #</th>
      <td mat-cell *matCellDef="let unparentedOrderAccounting">
        {{ unparentedOrderAccounting.partner?.partnerNo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="PartnerName">
      <th mat-header-cell *matHeaderCellDef>Partner</th>
      <td mat-cell *matCellDef="let unparentedOrderAccounting">
        {{ unparentedOrderAccounting.partner?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Description">
      <th mat-header-cell *matHeaderCellDef>Beskrivelse</th>
      <td mat-cell *matCellDef="let unparentedOrderAccounting">
        <div>{{ unparentedOrderAccounting.description }}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="Notice">
      <th mat-header-cell *matHeaderCellDef>Note</th>
      <td mat-cell *matCellDef="let unparentedOrderAccounting">
        <div>
          <i>{{ unparentedOrderAccounting.notice }}</i>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="OkKundeAftalenr">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Foreslået match</th>
      <td mat-cell *matCellDef="let unparentedOrderAccounting">
        <div>{{ unparentedOrderAccounting.okKundeAftalenr }}</div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="activeColumns"></tr>
    <tr
      mat-row
      (click)="onRowClick(row)"
      *matRowDef="let row; let i = index; columns: activeColumns"
      [class.active]="globalActiveRowID == row.id"
      [appScrollToRow]="prevRow"
      [rowId]="row.id"
      (rowActive)="highLight($event)"
    ></tr>
  </table>
  @if (page < pageCount) {
    <div class="align-center margin-top-x2">
      <button type="button" mat-raised-button color="accent" class="btn-trans mat-elevation-z0" (click)="more()">Vis flere</button>
    </div>
  }
</div>
